import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=d5b66d60&scoped=true"
import script from "./Inbox.vue?vue&type=script&lang=js"
export * from "./Inbox.vue?vue&type=script&lang=js"
import style0 from "./Inbox.vue?vue&type=style&index=0&id=d5b66d60&prod&lang=scss"
import style1 from "./Inbox.vue?vue&type=style&index=1&id=d5b66d60&prod&lang=scss&scoped=true"
import style2 from "vue-search-select/dist/VueSearchSelect.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b66d60",
  null
  
)

export default component.exports